/* Load optional libraries for sections added through the editor or Section API. */
window.theme = window.theme || {};
(() => {
  const pending = new Map();
  theme.loadScript = (key) => {
    if (pending.has(key)) return pending.get(key);
    const promise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = theme.assetUrls[key];
      script.onload = resolve;
      script.onerror = () => {
        pending.delete(key);
        script.remove();
        reject(new Error(`Unable to load theme asset: ${key}`));
      };
      document.head.append(script);
    });
    pending.set(key, promise);
    return promise;
  };
  theme.ensureSwiper = () => {
    if (window.Swiper) return Promise.resolve();
    const href = new URL(theme.assetUrls.swiperStyles, location.href).href;
    if (![...document.querySelectorAll('link[rel="stylesheet"]')].some(link => link.href === href)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      document.head.append(link);
    }
    return theme.loadScript('swiper');
  };
  const contains = (root, selector) => root.matches?.(selector) || root.querySelector?.(selector);
  const scan = (root) => {
    if (contains(root, 'swiper-gallery, .stories-slideshow')) {
      const ready = theme.ensureSwiper().then(() => {
        if (contains(root, '.stories-slideshow') && typeof EffectCarousel === 'undefined') {
          return theme.loadScript('carousel');
        }
      });
      ready.then(() => {
        if (!customElements.get('swiper-gallery')) return theme.loadScript('swiperComponents');
        if (typeof initStoriesSlideshow === 'function') initStoriesSlideshow();
      }).catch(console.error);
    }
    if (contains(root, 'banner-hscroll') && !customElements.get('banner-hscroll')) {
      theme.loadScript('bannerScroll').catch(console.error);
    }
  };
  document.addEventListener('DOMContentLoaded', () => {
    scan(document);
    new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) scan(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }, { once: true });
})();
